/**
 * カスタムセレクト（ドロップダウン）コンポーネント
 * hidden native selectと同期し、changeイベントをdispatchする
 */
const initSelectSearch = (container) => {
    const trigger = container.querySelector(".c-others-select-search__trigger");
    const label = container.querySelector(".c-others-select-search__label");
    const dropdown = container.querySelector(".c-others-select-search__dropdown");
    const options = container.querySelectorAll(".c-others-select-search__option");
    const nativeSelect = container.querySelector(".c-others-select-search__native");

    if (!trigger || !dropdown || !nativeSelect) return;

    // ドロップダウン開閉
    trigger.addEventListener("click", () => {
        const isOpen = container.hasAttribute("data-open");
        if (isOpen) {
            container.removeAttribute("data-open");
        } else {
            // 他のドロップダウンを閉じる
            document.querySelectorAll(".c-others-select-search[data-open]").forEach((el) => {
                el.removeAttribute("data-open");
            });
            container.setAttribute("data-open", "");
        }
    });

    // オプション選択
    options.forEach((option) => {
        option.addEventListener("click", () => {
            const value = option.dataset.value;
            const text = option.querySelector(".c-others-select-search__option-text").textContent;

            // ラベル更新
            label.textContent = text;

            // 選択状態更新
            options.forEach((opt) => opt.removeAttribute("data-selected"));
            option.setAttribute("data-selected", "");

            // native select同期 + changeイベント発火
            nativeSelect.value = value;
            nativeSelect.dispatchEvent(new Event("change", { bubbles: true }));

            // ドロップダウンを閉じる
            container.removeAttribute("data-open");
        });
    });

    // 外クリックで閉じる
    document.addEventListener("click", (e) => {
        if (!container.contains(e.target)) {
            container.removeAttribute("data-open");
        }
    });
};

const main = () => {
    const containers = document.querySelectorAll(".c-others-select-search");
    if (containers.length === 0) return;
    containers.forEach(initSelectSearch);
};

export default main;
